import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IBotApiListResponse, IBotSearchResponse } from '@/types/bot';
import { IBotUsageStatsApiResponse } from '@/types/botUsageStats';

export const botList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBotApiListResponse>> => {
    return axios.get('/api/bot/list', { ...config, params });
};

export const searchBots = (query: string): Promise<AxiosResponse<IBotSearchResponse>> => {
    return axios.get('/api/bot/search', { params: { query } });
};

export const botUsageStats = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBotUsageStatsApiResponse>> => {
    return axios.get('/api/bot/usageStats', { ...config, params });
};
